import React from "react";
import {Divider, Drawer, Tabs, TabsProps} from "antd";
import styles from "./SidePanel.module.css";

const SidePanel = (props: TabsProps & {
    isMobile: boolean
    onChange: ( k: string | undefined) => void
}) => {

    const { isMobile, onChange:c, ...tabProps } = props;

    const showSidePanel = !isMobile && props.activeKey;

    const handleTabClick = (key: string) => {
        props.onChange?.( ( key === props.activeKey )
                ? undefined
                : key );
    }

    return <>
        {showSidePanel &&
          <Divider type="vertical" style={{float: "left", height: "100%", paddingLeft: ".3rem", paddingRight: ".3rem" }} />
        }

        <div className={styles["right-panel"]} >
            <Tabs
                {...tabProps}
                items={props.items?.map((item, i) => (
                    {
                        ...item,
                        children: showSidePanel && item.children
                    }
                ))}
                onTabClick={handleTabClick}
                tabPosition="right"
            />
        </div>
        {isMobile &&
          <Drawer
            open={!!props.activeKey}
            onClose={() => props.onChange?.(undefined)}
          >
              {props.items
                  ?.filter((item, ) => props.activeKey === item.key )
                  .map((item, index) => item.children )}
          </Drawer>}
    </>
}

export default SidePanel;
